import { computedFrom, autoinject, bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { I18N } from 'aurelia-i18n';
import { Customer } from '../../models/customer';

@autoinject

export class MyWallet{
	errorMessage: any;
	validationErrors: any;
	customer: any;
	donotshow: any;
	successItem: any;
	contactInfo: any;
	isInvoiceEnabled: boolean;
	@bindable selectedCustomer: Customer;

	constructor(private router: Router, private payrazrService: PayrazrService, private globalState: State, private i18n: I18N) {
		this.errorMessage = '';
		this.validationErrors = [];
		this.customer = {};
		this.customer.paymentMethods = {};
		this.donotshow = false;
		this.isInvoiceEnabled = globalState.business.portalSettings.businessSettings.isInvoiceEnabled;
	}

	activate() {
		this.getCustomerPaymentMethods();
	}

	selectedCustomerChanged() {
		this.getCustomerPaymentMethods(this.selectedCustomer.id);
	}

	@computedFrom('customer.paymentMethods')
	get showEmptyCardGridMessage() {
		try {
			return this.customer.paymentMethods.creditCardPaymentMethods === undefined || this.customer.paymentMethods.creditCardPaymentMethods.length < 1;
		}
		catch (err) {
			return false;
		}
	}

	@computedFrom('customer.paymentMethods')
	get showEmptyAchAccountsGridMessage() {
		try {
			return this.customer.paymentMethods.achPaymentMethods === undefined || this.customer.paymentMethods.achPaymentMethods.length < 1;
		}
		catch (err) {
			return false;
		}
	}

	@computedFrom('globalState.business.portalSettings')
	get isWalletEnabled() {
		try {
			return 'consumerWalletEnabled' in this.globalState.business.portalSettings ? this.globalState.business.portalSettings.consumerWalletEnabled : true;
		}
		catch (err) {
			console.error('Failed to enable wallet.');
			return false;
		}
	}

	@computedFrom('globalState.hasCreditCardEnabledPortfolio')
	get showCardAccounts() {
		try {
			return this.globalState.hasCreditCardEnabledPortfolio;
		}
		catch (err) {
			console.error('Error identifying allowed payment methods.');
			return false;
		}
	}

	@computedFrom('globalState.hasECheckEnabledPortfolio')
	get showBankAccounts() {
		try {
			return this.globalState.hasECheckEnabledPortfolio;
		}
		catch (err) {
			console.error('Error identifying allowed payment methods.');
			return false;
		}
	}

	getRouteSettings() {
		return {
			redirectTo: 'myWallet'
		};
	}

	confirmPaymentDelete() {
		return confirm(this.i18n.i18next.t('deletePaymentMethodConfirmation', 'Are you sure you want to delete this payment method?'));
	}

	addNewPaymentMethod(paymentMethodType) {
		const addPaymentMethodRoute = this.router.routes.find(x => x.name === 'addPaymentMethod');
		addPaymentMethodRoute.paymentMethodType = paymentMethodType;
		addPaymentMethodRoute.isCreateMethod = true;
		addPaymentMethodRoute.customer = this.selectedCustomer || this.globalState.customer;

		this.router.navigateToRoute(addPaymentMethodRoute.name);
	}

	setCustomerPrimaryPaymentMethod(paymentMethodInfoKey, paymentMethodType) {
		let customerId = this.selectedCustomer ? this.selectedCustomer.id : null;
		return this.payrazrService.setCustomerPrimaryPaymentMethod(paymentMethodInfoKey, paymentMethodType, customerId).then(response => {
			if (!response.isSuccessful) {
				console.error(response.message);
			}

			this.getCustomerPaymentMethods(customerId);
		}).catch(err => {
			console.error('Error occurred while setting primary payment method.');
		});
	}

	editAccount(paymentMethodType, account) {
		const editPaymentMethodRoute = this.router.routes.find(x => x.name === 'editPaymentMethod');
		editPaymentMethodRoute.paymentMethodType = paymentMethodType;
		editPaymentMethodRoute.isCreateMethod = false;
		editPaymentMethodRoute.account = account;
		this.router.navigateToRoute(editPaymentMethodRoute.name);
	}

	removeAccount(paymentMethodType, paymentMethodInfoKey) {
		try {
			let customerId = this.globalState.customer.id;

			if (this.globalState.isConsumerPortalGuarantorBillingEnabled) {
				customerId = this.selectedCustomer.id;
			}

			if (this.confirmPaymentDelete()) {
				this.payrazrService.removePaymentMethod(paymentMethodType, paymentMethodInfoKey, customerId).then(response => {
					if (response.isSuccessful) {
						this.getCustomerPaymentMethods(customerId);
					} else {
						alert(response.message);
					}
				})
					.catch(err => {
						console.error(err);
					});
			}
		}
		catch (err) {
			console.error(err);
		}
	}

	getCustomerPaymentMethods(customerId: string = null) {
		this.payrazrService.getCustomerPaymentMethodsByCustomerId(customerId).then(response => {
			if (response.isSuccessful) {
				this.customer.paymentMethods = response.entity;
			} else {
				console.error(response.message);
			}
		}
		).catch(err => {
			console.error('Failed to retrieve customer payment methods');
		});
	}

	// Both this and avalableCustomerDescs are called multiple times by
	// the view for unsure reasons; if there's a notable performance lag
	// in the future when switching customers/patients, try debugging here.
	@computedFrom('globalState')
	get availableCustomers(): Customer[] {
		return [this.globalState.customer].concat(this.globalState.associatedCustomers);
	}

	@computedFrom('globalState')
	get availableCustomerDescs(): string[] {
		return [this.globalState.customer].concat(this.globalState.associatedCustomers).map(c => c.name);
	}
}
